/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"

const ZgodovinaTable = () => (
  <div id="zgodovina-vozila" className="collapsible-body">
    <ul id="tabs-swipe-zgodovina" className="tabs">
      <li className="tab col s3">
        <a href="#year-2014" className="active">
          2014
        </a>
      </li>

      <li className="tab col s3">
        <a href="#year-2015" className="">
          2015
        </a>
      </li>

      <li className="tab col s3">
        <a href="#year-2018" className="">
          2018
        </a>
      </li>

      <li className="tab col s3">
        <a href="#year-2019">2019</a>
      </li>
    </ul>

    <a className="year-anchor" id="year-2014"></a>
    <div id="swipe-2014">
      <h4>2014</h4>
      <table className="table-first-bold">
        <tbody>
          <tr>
            <th>Znamka vozila</th>
            <td>VOLKSWAGEN</td>
          </tr>

          <tr>
            <th>Tovarniška oznaka</th>
            <td>SEAVFX11-SGQM61E020NP0GE</td>
          </tr>

          <tr>
            <th>Komercialna oznaka</th>
            <td>PASSAT / VAR.1.9 / TDI 4M</td>
          </tr>

          <tr>
            <th>VIN</th>
            <td>WVWZZZ3BZ1E163567</td>
          </tr>

          <tr>
            <th>maksimalna dovoljena masa skupine vozil</th>
            <td>3830</td>
          </tr>

          <tr>
            <th>Masa vozila</th>
            <td>1550.0</td>
          </tr>

          <tr>
            <th>Oznaka kategorije vozila</th>
            <td>M1</td>
          </tr>

          <tr>
            <th>Opis kategorije vozila</th>
            <td>osebni avtomobil</td>
          </tr>

          <tr>
            <th>Homologacijska oznaka</th>
            <td>E1*98/14*0157*</td>
          </tr>

          <tr>
            <th>Število osi</th>
            <td>2</td>
          </tr>

          <tr>
            <th>Medosje</th>
            <td>2691.0</td>
          </tr>

          <tr>
            <th>Zadnji previs</th>
            <td>1017.0</td>
          </tr>

          <tr>
            <th>Dovoljene osne obremenitve</th>
            <td>1080/1150</td>
          </tr>

          <tr>
            <th>Priklopnik s centralno osjo</th>
            <td>1700.0</td>
          </tr>

          <tr>
            <th>Nezavirano priklopno vozilo</th>
            <td>650</td>
          </tr>

          <tr>
            <th>Navpična obremenitev</th>
            <td>75.0</td>
          </tr>

          <tr>
            <th>Delovna prostornina</th>
            <td>1896.0</td>
          </tr>

          <tr>
            <th>Nazivna moč</th>
            <td>96.0</td>
          </tr>

          <tr>
            <th>Opis vrste goriva</th>
            <td>Dizel</td>
          </tr>

          <tr>
            <th>Oznaka vrste goriva</th>
            <td>D</td>
          </tr>

          <tr>
            <th>Nazivna vrtilna frekvenca</th>
            <td>4000</td>
          </tr>

          <tr>
            <th>Oznaka motorja</th>
            <td>AVF</td>
          </tr>

          <tr>
            <th>Barva vozila</th>
            <td>navaden - CRNA - SREDNJA</td>
          </tr>

          <tr>
            <th>Oznaka barve vozila</th>
            <td>S9M</td>
          </tr>

          <tr>
            <th>Število sedežev</th>
            <td>5</td>
          </tr>

          <tr>
            <th>Najvišja hitrost</th>
            <td>201.0</td>
          </tr>

          <tr>
            <th>V mirovanju</th>
            <td>80.0</td>
          </tr>

          <tr>
            <th>Pri vrtilni frekvenci</th>
            <td>3000.0</td>
          </tr>

          <tr>
            <th>V vožnji</th>
            <td>74.0</td>
          </tr>

          <tr>
            <th>Kombinirana poraba vozila</th>
            <td>6.4</td>
          </tr>

          <tr>
            <th>Okoljevarstvena kategorija</th>
            <td>70/220*1999/102A (EURO 3)</td>
          </tr>

          <tr>
            <th>Oblika nadgradnje (oznaka)</th>
            <td>AC</td>
          </tr>

          <tr>
            <th>Oblika nadgradnje opis</th>
            <td>karavan</td>
          </tr>

          <tr>
            <th>Dolžina</th>
            <td>4682</td>
          </tr>

          <tr>
            <th>Širina</th>
            <td>1746</td>
          </tr>

          <tr>
            <th>Višina</th>
            <td>1498</td>
          </tr>

          <tr>
            <th>Dovoljene pnevmatike in platišča</th>
            <td>
              195/65 R15 91V, 195/65 R15 91Q M+S, 205/55R16 91T M+S, 205/55 R 16
              91V, 205/60 R15 91V, 225/45 R17 91V.
            </td>
          </tr>

          <tr>
            <th>Homologacija vlečne naprave</th>
            <td>DA</td>
          </tr>

          <tr>
            <th>Okoljevarstvena oznaka</th>
            <td>EURO 3</td>
          </tr>

          <tr>
            <th>Komercialni tip</th>
            <td>PASSAT </td>
          </tr>

          <tr>
            <th>Datum prve registracije</th>
            <td>2001-02-28</td>
          </tr>

          <tr>
            <th>Proizvajalec</th>
            <td>VOLKSWAGEN AG</td>
          </tr>

          <tr>
            <th>Razlog za tehnični zapisnik</th>
            <td>Redni tehnicni pregled</td>
          </tr>

          <tr>
            <th>Datum statusa ZTP</th>
            <td>2014-02-27</td>
          </tr>

          <tr>
            <th>Izvajalna enota tehničnega pregleda</th>
            <td>AMZS D.D. PE DRAVOGRAD</td>
          </tr>
        </tbody>
      </table>
    </div>

    <a className="year-anchor" id="year-2015"></a>
    <div id="swipe-2015">
      <h4>2015</h4>
      <table className="table-first-bold">
        <tbody>
          <tr>
            <th>lastnik</th>
            <td>F ( fizična oseba)</td>
          </tr>

          <tr>
            <th>uporabnik</th>
            <td>F ( fizična oseba)</td>
          </tr>

          <tr>
            <th>Prevoženi kilometri ali milje</th>
            <td>289212.0</td>
          </tr>

          <tr>
            <th>Znamka vozila</th>
            <td>VOLKSWAGEN</td>
          </tr>

          <tr>
            <th>Tovarniška oznaka</th>
            <td>SEAVFX11-SGQM61E020NP0GE</td>
          </tr>

          <tr>
            <th>Komercialna oznaka</th>
            <td>PASSAT / VAR.1.9 / TDI 4M</td>
          </tr>

          <tr>
            <th>VIN</th>
            <td>WVWZZZ3BZ1E163567</td>
          </tr>

          <tr>
            <th>maksimalna dovoljena masa skupine vozil</th>
            <td>3830</td>
          </tr>

          <tr>
            <th>Masa vozila</th>
            <td>1550.0</td>
          </tr>

          <tr>
            <th>Oznaka kategorije vozila</th>
            <td>M1</td>
          </tr>

          <tr>
            <th>Opis kategorije vozila</th>
            <td>osebni avtomobil</td>
          </tr>

          <tr>
            <th>Homologacijska oznaka</th>
            <td>E1*98/14*0157*</td>
          </tr>

          <tr>
            <th>Število osi</th>
            <td>2</td>
          </tr>

          <tr>
            <th>Medosje</th>
            <td>2691.0</td>
          </tr>

          <tr>
            <th>Zadnji previs</th>
            <td>1017.0</td>
          </tr>

          <tr>
            <th>Dovoljene osne obremenitve</th>
            <td>1080/1150</td>
          </tr>

          <tr>
            <th>Priklopnik s centralno osjo</th>
            <td>1700.0</td>
          </tr>

          <tr>
            <th>Nezavirano priklopno vozilo</th>
            <td>650</td>
          </tr>

          <tr>
            <th>Navpična obremenitev</th>
            <td>75.0</td>
          </tr>

          <tr>
            <th>Delovna prostornina</th>
            <td>1896.0</td>
          </tr>

          <tr>
            <th>Nazivna moč</th>
            <td>96.0</td>
          </tr>

          <tr>
            <th>Opis vrste goriva</th>
            <td>Dizel</td>
          </tr>

          <tr>
            <th>Oznaka vrste goriva</th>
            <td>D</td>
          </tr>

          <tr>
            <th>Nazivna vrtilna frekvenca</th>
            <td>4000</td>
          </tr>

          <tr>
            <th>Oznaka motorja</th>
            <td>AVF</td>
          </tr>

          <tr>
            <th>Barva vozila</th>
            <td>navaden - ÄŚRNA - SREDNJA</td>
          </tr>

          <tr>
            <th>Oznaka barve vozila</th>
            <td>S9M</td>
          </tr>

          <tr>
            <th>Število sedežev</th>
            <td>5</td>
          </tr>

          <tr>
            <th>Najvišja hitrost</th>
            <td>201.0</td>
          </tr>

          <tr>
            <th>V mirovanju</th>
            <td>80.0</td>
          </tr>

          <tr>
            <th>Pri vrtilni frekvenci</th>
            <td>3000.0</td>
          </tr>

          <tr>
            <th>V vožnji</th>
            <td>74.0</td>
          </tr>

          <tr>
            <th>Kombinirana poraba vozila</th>
            <td>6.4</td>
          </tr>

          <tr>
            <th>Okoljevarstvena kategorija</th>
            <td>70/220*1999/102A (EURO 3)</td>
          </tr>

          <tr>
            <th>Oblika nadgradnje (oznaka)</th>
            <td>AC</td>
          </tr>

          <tr>
            <th>Oblika nadgradnje opis</th>
            <td>karavan</td>
          </tr>

          <tr>
            <th>Dolžina</th>
            <td>4682</td>
          </tr>

          <tr>
            <th>Širina</th>
            <td>1746</td>
          </tr>

          <tr>
            <th>Višina</th>
            <td>1498</td>
          </tr>

          <tr>
            <th>Dovoljene pnevmatike in platišča</th>
            <td>
              195/65 R15 91V,195/65 R15 91Q M+S,205/55R16 91T M+S,205/55 R 16
              91V,205/60 R15 91V,225/45 R17 91V.
            </td>
          </tr>

          <tr>
            <th>Homologacija vlečne naprave</th>
            <td>DA</td>
          </tr>

          <tr>
            <th>Okoljevarstvena oznaka</th>
            <td>EURO 3</td>
          </tr>

          <tr>
            <th>Komercialni tip</th>
            <td>PASSAT</td>
          </tr>

          <tr>
            <th>Datum prve registracije</th>
            <td>2001-02-28</td>
          </tr>

          <tr>
            <th>Proizvajalec</th>
            <td>VOLKSWAGEN AG</td>
          </tr>

          <tr>
            <th>Razlog za tehnični zapisnik</th>
            <td>Redni tehniÄŤni pregled</td>
          </tr>

          <tr>
            <th>Datum statusa ZTP</th>
            <td>2015-03-02</td>
          </tr>

          <tr>
            <th>Izvajalna enota tehničnega pregleda</th>
            <td>AVTOSERVIS d.o.o.</td>
          </tr>

          <tr>
            <th>DG_LUC_L</th>
            <td>1</td>
          </tr>

          <tr>
            <th>DG_LUC_D</th>
            <td>1</td>
          </tr>

          <tr>
            <th>KR_LUC_L</th>
            <td>1</td>
          </tr>

          <tr>
            <th>KR_LUC_D</th>
            <td>1</td>
          </tr>

          <tr>
            <th>MEG_L</th>
            <td>9</td>
          </tr>

          <tr>
            <th>MEG_D</th>
            <td>9</td>
          </tr>
        </tbody>
      </table>
    </div>

    <a className="year-anchor" id="year-2018"></a>
    <div id="swipe-2018">
      <h4>2018</h4>
      <table className="table-first-bold">
        <tbody>
          <tr>
            <th>lastnik</th>
            <td>F ( fizična oseba)</td>
          </tr>

          <tr>
            <th>uporabnik</th>
            <td>F ( fizična oseba)</td>
          </tr>

          <tr>
            <th>Prevoženi kilometri ali milje</th>
            <td>247290.0</td>
          </tr>

          <tr>
            <th>Znamka vozila</th>
            <td>VOLKSWAGEN</td>
          </tr>

          <tr>
            <th>Tovarniška oznaka</th>
            <td>SEAVFX11-SGQM61E020NP0GE</td>
          </tr>

          <tr>
            <th>Komercialna oznaka</th>
            <td>PASSAT / VAR.1.9 / TDI 4M</td>
          </tr>

          <tr>
            <th>VIN</th>
            <td>WVWZZZ3BZ1E163567</td>
          </tr>

          <tr>
            <th>maksimalna dovoljena masa skupine vozil</th>
            <td>3830</td>
          </tr>

          <tr>
            <th>Masa vozila</th>
            <td>1550.0</td>
          </tr>

          <tr>
            <th>Oznaka kategorije vozila</th>
            <td>M1</td>
          </tr>

          <tr>
            <th>Opis kategorije vozila</th>
            <td>osebni avtomobil</td>
          </tr>

          <tr>
            <th>Homologacijska oznaka</th>
            <td>E1*98/14*0157*</td>
          </tr>

          <tr>
            <th>Število osi</th>
            <td>2</td>
          </tr>

          <tr>
            <th>Medosje</th>
            <td>2691.0</td>
          </tr>

          <tr>
            <th>Zadnji previs</th>
            <td>1017.0</td>
          </tr>

          <tr>
            <th>Dovoljene osne obremenitve</th>
            <td>1080/1150</td>
          </tr>

          <tr>
            <th>Priklopnik s centralno osjo</th>
            <td>1700.0</td>
          </tr>

          <tr>
            <th>Nezavirano priklopno vozilo</th>
            <td>650</td>
          </tr>

          <tr>
            <th>Navpična obremenitev</th>
            <td>75.0</td>
          </tr>

          <tr>
            <th>Delovna prostornina</th>
            <td>1896.0</td>
          </tr>

          <tr>
            <th>Nazivna moč</th>
            <td>96.0</td>
          </tr>

          <tr>
            <th>Opis vrste goriva</th>
            <td>Dizel</td>
          </tr>

          <tr>
            <th>Oznaka vrste goriva</th>
            <td>D</td>
          </tr>

          <tr>
            <th>Nazivna vrtilna frekvenca</th>
            <td>4000</td>
          </tr>

          <tr>
            <th>Oznaka motorja</th>
            <td>AVF</td>
          </tr>

          <tr>
            <th>Barva vozila</th>
            <td>navaden - ČRNA - SREDNJA</td>
          </tr>

          <tr>
            <th>Oznaka barve vozila</th>
            <td>S9M</td>
          </tr>

          <tr>
            <th>Število sedežev</th>
            <td>5</td>
          </tr>

          <tr>
            <th>Najvišja hitrost</th>
            <td>201.0</td>
          </tr>

          <tr>
            <th>V mirovanju</th>
            <td>80.0</td>
          </tr>

          <tr>
            <th>Pri vrtilni frekvenci</th>
            <td>3000.0</td>
          </tr>

          <tr>
            <th>V vožnji</th>
            <td>74.0</td>
          </tr>

          <tr>
            <th>Kombinirana poraba vozila</th>
            <td>6.4</td>
          </tr>

          <tr>
            <th>Okoljevarstvena kategorija</th>
            <td>70/220*1999/102A (EURO 3)</td>
          </tr>

          <tr>
            <th>Oblika nadgradnje (oznaka)</th>
            <td>AC</td>
          </tr>

          <tr>
            <th>Oblika nadgradnje opis</th>
            <td>karavan</td>
          </tr>

          <tr>
            <th>Dolžina</th>
            <td>4682</td>
          </tr>

          <tr>
            <th>Širina</th>
            <td>1746</td>
          </tr>

          <tr>
            <th>Višina</th>
            <td>1498</td>
          </tr>

          <tr>
            <th>Dovoljene pnevmatike in platišča</th>
            <td>
              195/65 R15 91V,195/65 R15 91Q M+S,205/55R16 91T M+S,205/55 R 16
              91V,205/60 R15 91V,225/45 R17 91V.
            </td>
          </tr>

          <tr>
            <th>Homologacija vlečne naprave</th>
            <td>DA</td>
          </tr>

          <tr>
            <th>Okoljevarstvena oznaka</th>
            <td>EURO 3</td>
          </tr>

          <tr>
            <th>Komercialni tip</th>
            <td>PASSAT </td>
          </tr>

          <tr>
            <th>Datum prve registracije</th>
            <td>2001-02-28</td>
          </tr>

          <tr>
            <th>Proizvajalec</th>
            <td>VOLKSWAGEN AG</td>
          </tr>

          <tr>
            <th>Razlog za tehnični zapisnik</th>
            <td>Redni tehnični pregled</td>
          </tr>

          <tr>
            <th>Datum statusa ZTP</th>
            <td>2018-10-19</td>
          </tr>

          <tr>
            <th>Izvajalna enota tehničnega pregleda</th>
            <td>AVTO KRKA GR. d.o.o.PE Škofja Loka</td>
          </tr>

          <tr>
            <th>OS1_R</th>
            <td>30.0</td>
          </tr>

          <tr>
            <th>OS2_R</th>
            <td>18.0</td>
          </tr>

          <tr>
            <th>OS1P_R</th>
            <td>9.0</td>
          </tr>

          <tr>
            <th>OSD_U</th>
            <td>63</td>
          </tr>

          <tr>
            <th>OSP_S</th>
            <td>395</td>
          </tr>

          <tr>
            <th>OSP_U</th>
            <td>23</td>
          </tr>

          <tr>
            <th>EM_DIM</th>
            <td>0.35</td>
          </tr>

          <tr>
            <th>PROFIL</th>
            <td>5.1</td>
          </tr>

          <tr>
            <th>DG_LUC_L</th>
            <td>1</td>
          </tr>

          <tr>
            <th>DG_LUC_D</th>
            <td>1</td>
          </tr>

          <tr>
            <th>KR_LUC_L</th>
            <td>1</td>
          </tr>

          <tr>
            <th>KR_LUC_D</th>
            <td>1</td>
          </tr>

          <tr>
            <th>OS1_L</th>
            <td>414.0</td>
          </tr>

          <tr>
            <th>OS1_D</th>
            <td>288.0</td>
          </tr>

          <tr>
            <th>OS1_S</th>
            <td>703.0</td>
          </tr>

          <tr>
            <th>OS1_GJ</th>
            <td>964.0</td>
          </tr>

          <tr>
            <th>OS2_L</th>
            <td>171.0</td>
          </tr>

          <tr>
            <th>OS2_D</th>
            <td>209.0</td>
          </tr>

          <tr>
            <th>OS2_S</th>
            <td>381.0</td>
          </tr>

          <tr>
            <th>OS2_GJ</th>
            <td>788.0</td>
          </tr>

          <tr>
            <th>OS1P_L</th>
            <td>188.0</td>
          </tr>

          <tr>
            <th>OS1P_D</th>
            <td>207.0</td>
          </tr>

          <tr>
            <th>OS1P_S</th>
            <td>395.0</td>
          </tr>

          <tr>
            <th>OSD_S</th>
            <td>1084</td>
          </tr>

          <tr>
            <th>OST</th>
            <td>1752</td>
          </tr>
        </tbody>
      </table>
    </div>

    <a className="year-anchor" id="year-2019"></a>
    <div id="swipe-2019">
      <h4>2019</h4>
      <table className="table-first-bold">
        <tbody>
          <tr>
            <th>Lastnik</th>
            <td>F ( fizična oseba)</td>
          </tr>

          <tr>
            <th>Uporabnik</th>
            <td>F ( fizična oseba)</td>
          </tr>

          <tr>
            <th>Prevoženi kilometri ali milje</th>
            <td>281514.0</td>
          </tr>

          <tr>
            <th>Znamka vozila</th>
            <td>VOLKSWAGEN</td>
          </tr>

          <tr>
            <th>Tovarniška oznaka</th>
            <td>SEAVFX11-SGQM61E020NP0GE</td>
          </tr>

          <tr>
            <th>Komercialna oznaka</th>
            <td>PASSAT / VAR.1.9 / TDI 4M</td>
          </tr>

          <tr>
            <th>VIN</th>
            <td>WVWZZZ3BZ1E163567</td>
          </tr>

          <tr>
            <th>maksimalna dovoljena masa skupine vozil</th>
            <td>3830</td>
          </tr>

          <tr>
            <th>Masa vozila</th>
            <td>1550.0</td>
          </tr>

          <tr>
            <th>Oznaka kategorije vozila</th>
            <td>M1</td>
          </tr>

          <tr>
            <th>Opis kategorije vozila</th>
            <td>osebni avtomobil</td>
          </tr>

          <tr>
            <th>Homologacijska oznaka</th>
            <td>E1*98/14*0157*</td>
          </tr>

          <tr>
            <th>Število osi</th>
            <td>2</td>
          </tr>

          <tr>
            <th>Medosje</th>
            <td>2691.0</td>
          </tr>

          <tr>
            <th>Zadnji previs</th>
            <td>1017.0</td>
          </tr>

          <tr>
            <th>Dovoljene osne obremenitve</th>
            <td>1080/1150</td>
          </tr>

          <tr>
            <th>Priklopnik s centralno osjo</th>
            <td>1700.0</td>
          </tr>

          <tr>
            <th>Nezavirano priklopno vozilo</th>
            <td>650</td>
          </tr>

          <tr>
            <th>Navpična obremenitev</th>
            <td>75.0</td>
          </tr>

          <tr>
            <th>Delovna prostornina</th>
            <td>1896.0</td>
          </tr>

          <tr>
            <th>Nazivna moč</th>
            <td>96.0</td>
          </tr>

          <tr>
            <th>Opis vrste goriva</th>
            <td>Dizel</td>
          </tr>

          <tr>
            <th>Oznaka vrste goriva</th>
            <td>D</td>
          </tr>

          <tr>
            <th>Nazivna vrtilna frekvenca</th>
            <td>4000</td>
          </tr>

          <tr>
            <th>Oznaka motorja</th>
            <td>AVF</td>
          </tr>

          <tr>
            <th>Barva vozila</th>
            <td>navaden - ČRNA - SREDNJA</td>
          </tr>

          <tr>
            <th>Oznaka barve vozila</th>
            <td>S9M</td>
          </tr>

          <tr>
            <th>Število sedežev</th>
            <td>5</td>
          </tr>

          <tr>
            <th>Najvišja hitrost</th>
            <td>201.0</td>
          </tr>

          <tr>
            <th>V mirovanju</th>
            <td>80.0</td>
          </tr>

          <tr>
            <th>Pri vrtilni frekvenci</th>
            <td>3000.0</td>
          </tr>

          <tr>
            <th>V vožnji</th>
            <td>74.0</td>
          </tr>

          <tr>
            <th>Kombinirana poraba vozila</th>
            <td>6.4</td>
          </tr>

          <tr>
            <th>Okoljevarstvena kategorija</th>
            <td>70/220*1999/102A (EURO 3)</td>
          </tr>

          <tr>
            <th>Oblika nadgradnje (oznaka)</th>
            <td>AC</td>
          </tr>

          <tr>
            <th>Oblika nadgradnje opis</th>
            <td>karavan</td>
          </tr>

          <tr>
            <th>Dolžina</th>
            <td>4682</td>
          </tr>

          <tr>
            <th>Širina</th>
            <td>1746</td>
          </tr>

          <tr>
            <th>Višina</th>
            <td>1498</td>
          </tr>

          <tr>
            <th>Dovoljene pnevmatike in platišča</th>
            <td>
              195/65 R15 91V,195/65 R15 91Q M+S,205/55R16 91T M+S,205/55 R 16
              91V,205/60 R15 91V,225/45 R17 91V.
            </td>
          </tr>

          <tr>
            <th>Homologacija vlečne naprave</th>
            <td>DA</td>
          </tr>

          <tr>
            <th>Okoljevarstvena oznaka</th>
            <td>EURO 3</td>
          </tr>

          <tr>
            <th>Komercialni tip</th>
            <td>PASSAT </td>
          </tr>

          <tr>
            <th>Datum prve registracije</th>
            <td>2001-02-28</td>
          </tr>

          <tr>
            <th>Proizvajalec</th>
            <td>VOLKSWAGEN AG</td>
          </tr>

          <tr>
            <th>Razlog za tehnični zapisnik</th>
            <td>Redni tehnični pregled</td>
          </tr>

          <tr>
            <th>Datum statusa ZTP</th>
            <td>2019-10-18</td>
          </tr>

          <tr>
            <th>Izvajalna enota tehničnega pregleda</th>
            <td>A.M. MIKLAVC D.O.O. PE VELENJE</td>
          </tr>

          <tr>
            <th>OS1_R</th>
            <td>16.0</td>
          </tr>

          <tr>
            <th>OS2_R</th>
            <td>20.0</td>
          </tr>

          <tr>
            <th>OS1P_R</th>
            <td>8.0</td>
          </tr>

          <tr>
            <th>OSD_U</th>
            <td>53</td>
          </tr>

          <tr>
            <th>OSP_U</th>
            <td>16</td>
          </tr>

          <tr>
            <th>EM_DIM</th>
            <td>0.54</td>
          </tr>

          <tr>
            <th>DG_LUC_L</th>
            <td>1</td>
          </tr>

          <tr>
            <th>DG_LUC_D</th>
            <td>1</td>
          </tr>

          <tr>
            <th>KR_LUC_L</th>
            <td>1</td>
          </tr>

          <tr>
            <th>KR_LUC_D</th>
            <td>1</td>
          </tr>

          <tr>
            <th>MEG_L</th>
            <td>9</td>
          </tr>

          <tr>
            <th>MEG_D</th>
            <td>9</td>
          </tr>

          <tr>
            <th>OS1_L</th>
            <td>226.0</td>
          </tr>

          <tr>
            <th>OS1_D</th>
            <td>268.0</td>
          </tr>

          <tr>
            <th>OS1_S</th>
            <td>494.0</td>
          </tr>

          <tr>
            <th>OS1_GJ</th>
            <td>926.0</td>
          </tr>

          <tr>
            <th>OS2_L</th>
            <td>163.0</td>
          </tr>

          <tr>
            <th>OS2_D</th>
            <td>204.0</td>
          </tr>

          <tr>
            <th>OS2_S</th>
            <td>367.0</td>
          </tr>

          <tr>
            <th>OS2_GJ</th>
            <td>687.0</td>
          </tr>

          <tr>
            <th>OS1P_L</th>
            <td>178.0</td>
          </tr>

          <tr>
            <th>OS1P_D</th>
            <td>164.0</td>
          </tr>

          <tr>
            <th>OS1P_S</th>
            <td>342.0</td>
          </tr>

          <tr>
            <th>OSD_S</th>
            <td>861</td>
          </tr>

          <tr>
            <th>OST</th>
            <td>1613</td>
          </tr>

          <tr>
            <th>PT_VRT</th>
            <td>1070</td>
          </tr>

          <tr>
            <th>POV_VRT</th>
            <td>5020</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
)

export default ZgodovinaTable
